/**
 * The permission catalogue — PERMISSION_MATRIX.md §8.1 (Q1–Q48) and §9.1 (C1–C96).
 *
 * `permissions.catalogue.json` is GENERATED by `scripts/generate-permissions.mjs`
 * directly from the matrix tables. The matrix is the authority; this is a
 * projection of it. No permission, capability or predicate is invented here —
 * `PERMISSION_MATRIX.md` §0.4 and `API_CONTRACT.md` §4.1 both forbid it.
 *
 * Cells that carry an EXPRESSION rather than a list (`R6` ∨ `R7`, `cus` (quote)
 * ∨ `own` (request-to-book), "`R7` only") are kept verbatim in `*_raw` and
 * flagged `*_ambiguous`. They are deliberately NOT machine-parsed: the matrix
 * states conditions this projection does not model, and guessing a parse would
 * silently weaken an authorization rule. A route whose rule is ambiguous must be
 * enforced by hand against the matrix text.
 */
import catalogue from './permissions.catalogue.json' with { type: 'json' };
const CATALOGUE = catalogue;
export const PERMISSIONS = CATALOGUE.permissions;
export const RELATIONSHIP_PREDICATES = CATALOGUE.predicates;
export const PERMISSION_COUNTS = CATALOGUE.counts;
const BY_CODE = new Map(PERMISSIONS.map((p) => [p.code, p]));
export function lookupPermission(code) {
    return BY_CODE.get(code);
}
/** Throws at the call site rather than letting an unknown code reach a route. */
export function requirePermissionRule(code) {
    const rule = BY_CODE.get(code);
    if (!rule) {
        throw new Error(`Unknown permission code "${code}". PERMISSION_MATRIX.md §8.1/§9.1 is the authority; ` +
            'no code may be invented at a route.');
    }
    return rule;
}
/** The six capabilities of `BR-1.1`, plus the matrix's own `anon` / `any` / `own`. */
/**
 * Every capability token either matrix uses.
 *
 * The first seven are PERMISSION_MATRIX.md's. The `cl_` five are
 * CITYLOAD_PERMISSION_MATRIX.md's — TeraAgo has a driver, a customer and a
 * dispatcher, none of which map onto an Equipment Rental role, so they are
 * their own tokens rather than a reuse of `cus` or `adm` that would let a
 * TeraAgo route resolve an ERM rule.
 */
export const MATRIX_CAPABILITY_TOKENS = [
    'anon',
    'any',
    'own',
    'cus',
    'adm',
    'sup',
    'fin',
    'cl_customer',
    'cl_driver',
    'cl_admin',
    'cl_company',
];
//# sourceMappingURL=permissions.js.map